import React, { useEffect, useState } from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import { InputLabel, Select, ExpansionPanel, FormControl, ExpansionPanelSummary, ExpansionPanelDetails, Typography, MenuItem, FormControlLabel, Checkbox } from '@material-ui/core';
import MultiSelect from '../../../../np-components/MultiSelect/MultiSelect';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core';
import { Redirect } from 'react-router-dom';
import * as formUtility from '../../../../np-form/utility';
import { snackActions } from '../../../../sc-utilities/SnackBar';
import History from "../../../../../History";

const styles = theme => ({
    userActive: {
        color: theme.palette.success.dark,
        marginTop: 8.5,
        fontSize: 15
    },
    userInactive: {
        color: theme.palette.error.dark,
        padding: 1,
        margin: 1,
        fontSize: 15
    },
    button: {
        borderRadius: '1px'
    },
    buttons: {
        textAlign: 'right',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    }
});

function getSteps(stepsContent) {
    return stepsContent.map(step => step.label)
}
function getStepContent(props) {
    const { translations, getExcludedPermissionsSelectData, getIncludedPermissionsSelectData, label, roles, setDefaultRole, role, permissions, allPermissionIncludeSelected, allPermissionIncluded, selectedExcludedPermissions, hasAccessAllGroupsPermission, assignRoleToAllCustomers, setAssignRoleToAllCustomers, hasAssignRoleToAllCustomersPermission } = props

    return (<div >
        <FormControl margin="dense" style={{ width: '100%' }}>
            <InputLabel margin="dense">{translations["role"] || 'Role'}</InputLabel>
            <Select
                labelId="demo-mutiple-name-label"
                id="demo-mutiple-name"
                value={role[`${label}`] ? role[`${label}`] : role["Operator"]}
                fullWidth={true}
                onChange={(event) => setDefaultRole(event.target.value, label)}

            >
                {roles.map((rol, index) => {
                    return (
                        <MenuItem key={index} value={rol.value} >{rol.displayValue}</MenuItem >
                    )
                })}

            </Select>
        </FormControl>

        <ExpansionPanel style={{ marginTop: '10px' }}>
            <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography> {translations["permission_for_role"] || 'Permission for this role'} </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{ display: 'block' }}>

                {permissions.map((permission, index) => {
                    return (
                        <p style={{ display: 'inline-block' }} key={index}  >
                            {permission.label}{' | '}
                        </p>
                    )
                })}
            </ExpansionPanelDetails>
        </ExpansionPanel>
        {hasAccessAllGroupsPermission && <MultiSelect
            customLabel={translations["included_permissions"] || "Included permissions"}
            selectOptions={allPermissionIncluded}
            selectedOptions={allPermissionIncludeSelected}
            placeholder={translations["chose_included_permissions"] || 'Choose included permissions'}
            name={'filters'}
            fullWidth={true}
            margin="dense"
            isMulti={true}
            getMultiSelectData={getIncludedPermissionsSelectData}
        />}
        <br />
        {hasAccessAllGroupsPermission && <MultiSelect
            fullWidth={true}
            margin="dense"
            isMulti={true}
            customLabel={translations["excluded_permissions"] || "Excluded permissions"}
            selectOptions={permissions}
            selectedOptions={selectedExcludedPermissions}
            placeholder={translations["chose_excluded_permissions"] || 'Choose excluded permissions'}
            name={'filters'}
            getMultiSelectData={getExcludedPermissionsSelectData}
        />}
        <br />
        {hasAssignRoleToAllCustomersPermission && <FormControl fullWidth={true}>
            <FormControlLabel
                label={translations['assign_role_to_all_customers'] || "Assign role to all customers"}
                control={
                    <Checkbox
                        checked={assignRoleToAllCustomers} onChange={(event, checked) => setAssignRoleToAllCustomers(checked)} name='AssignRoleToAllCustomers' />} >
            </FormControlLabel>
        </FormControl>}
    </div>)
}

const RoleForCustomer = props => {
    const { classes, translations, customers, customersSelect, activeCustomer, userFormValue, onLoadRoles, fetchPermission, setActiveSteps, hasAccessAllGroupsPermission, hasAssignRoleToAllCustomersPermission } = props;
    let stepsContent = customers.filter(itemX => customersSelect.includes(itemX.value));
    const [activeStep, setActiveStep] = React.useState(0);
    const [activeLabel, setActiveLabel] = React.useState({ label: '' });
    const [roles, setRoles] = useState([]);
    const [role, setRole] = useState();
    const [data, setData] = useState({});
    const [permissions, setPermissions] = useState([]);
    const [allPermissionIncludeSelected, setAllPermissionIncludeSelected] = useState([]);
    const [allPermissionIncluded, setAllPermissionIncluded] = useState([]);
    const [selectedExcludedPermissions, setSelectedExcludedPermissions] = useState([]);
    const [assignRoleToAllCustomers, setAssignRoleToAllCustomers] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            let roleData = await onLoadRoles({ ActiveCustomerID: activeCustomer });
            const operatorRole = roleData.find((r) => r.displayValue==="Operator");
            if (operatorRole) {
                setActiveLabel({ label: operatorRole.displayValue })
                setRole({[operatorRole.displayValue]: operatorRole.value});
            }
            setRoles(roleData);
        }
        fetchData();
        return () => {
        };
    }, [activeCustomer, onLoadRoles, activeStep]);

    const setDefaultRole = (event, label) => {
        setActiveLabel({ label: label })
        setRole({ ...role, [label]: event })
    }

    const getExcludedPermissionsSelectData = (...params) => {
        setSelectedExcludedPermissions(params[0])
    };

    const getIncludedPermissionsSelectData = (...params) => {
        setAllPermissionIncludeSelected(params[0]);
    };

    useEffect(() => {
        const fetchData = async () => {
            let permissionDataAll = await fetchPermission({ ActiveCustomerID: activeCustomer });
            let permissionDataRole = await fetchPermission({ ActiveCustomerID: activeCustomer, RoleID: role[activeLabel['label']] ? role[activeLabel['label']] : 1 });
            let yFilter = permissionDataRole.map(itemY => { return itemY.value; });
            let filteredX = permissionDataAll.filter(itemX => !yFilter.includes(itemX.value));
            setPermissions(permissionDataRole);
            setAllPermissionIncluded(filteredX)
            setAllPermissionIncludeSelected([])
            setSelectedExcludedPermissions([])
        }
        role && fetchData();
        return () => {
        };
    }, [activeCustomer, fetchPermission, role, activeStep, activeLabel]);
    const steps = getSteps(stepsContent);

    function getStepsContent(step, label) {
        switch (step) {
            default:
                return getStepContent({ translations, getExcludedPermissionsSelectData: getExcludedPermissionsSelectData, getIncludedPermissionsSelectData: getIncludedPermissionsSelectData, label: label, roles: roles, setDefaultRole: setDefaultRole, role: role, permissions: permissions, allPermissionIncludeSelected: allPermissionIncludeSelected, allPermissionIncluded: allPermissionIncluded, selectedExcludedPermissions: selectedExcludedPermissions, hasAccessAllGroupsPermission, assignRoleToAllCustomers, setAssignRoleToAllCustomers, hasAssignRoleToAllCustomersPermission });
        }
    }

    const handleNext = (label) => {
        let stepsContent = customers.filter(itemX => label === itemX.label);
        setActiveStep(prevActiveStep => prevActiveStep + 1);
        setData({
            ...data,
            [label]: {
                RoleID: { CustomerID: stepsContent[0].value, RoleID: role[activeLabel['label']] ? role[activeLabel['label']] : 2, AssignRoleToAllCustomers: assignRoleToAllCustomers },
                IncludePermission: allPermissionIncludeSelected.map(id => ({ CustomerID: stepsContent[0].value, PermissionID: id, Mode: 'included' })),
                ExcludedPermissions: selectedExcludedPermissions.map(id => ({ CustomerID: stepsContent[0].value, PermissionID: id, Mode: 'excluded' }))
            }
        })
        setAllPermissionIncludeSelected([])
        setSelectedExcludedPermissions([])
        setAssignRoleToAllCustomers(false);
    };

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1);
        setAllPermissionIncludeSelected([])
        setSelectedExcludedPermissions([])
        setAssignRoleToAllCustomers(false);
    };
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, productID: null, redirectPath: '' });

    const handleFinish = async () => {
        const roleID = []
        const includePermissions = []
        const excludedPermissions = []
        for (var value of Object.values(data)) {
            roleID.push(value['RoleID'])
            includePermissions.push(...value['IncludePermission'])
            excludedPermissions.push(...value['ExcludedPermissions'])
        }
        let userFormDetails = formUtility.getFormData(userFormValue);

        let user = await props.onCreateUser({ ExcludedPermissions: excludedPermissions, IncludedPermissions: includePermissions, UserDetails: { ...userFormDetails }, Customers: customersSelect, Roles: roleID, GroupID: userFormDetails["GroupID"], ActiveCustomerID: activeCustomer })

        if (!user) {
            setAllPermissionIncludeSelected([])
            setSelectedExcludedPermissions([])
            setAssignRoleToAllCustomers(false)
            setRedirectOptions({ redirect: true, redirectPath: `/account-management/users` });
            return
        }
        if (user) {
            snackActions.snackBar(user)
            return
        }

    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    const cancelHandler = () => {
        History.goBack();
    };

    return (
        <div className={classes.root}>
            <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((label, index) => (
                    <Step key={index}>
                        <StepLabel>{label}</StepLabel>
                        <StepContent>
                            {role && roles && getStepsContent(index, label)}
                            <div className={classes.actionsContainer}>
                                <div>
                                    <Button onClick={cancelHandler} className={classes.button} variant="contained">
                                        {translations["cancel"] || 'Cancel'}
                                    </Button>
                                    <Button
                                        disabled={activeStep === 0}
                                        onClick={handleBack}
                                        className={classes.button}
                                    >
                                        {translations["back"] || 'BACK'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color={'primary'}
                                        onClick={() => handleNext(label)}
                                        className={classes.button}
                                    >
                                        {translations["next"] || 'NEXT'}
                                    </Button>
                                </div>
                            </div>
                        </StepContent>
                    </Step>
                ))}
            </Stepper>
            <div style={{ float: 'right', marginTop: '-70px' }}>
                {activeStep === steps.length && (
                    <Paper square elevation={0} className={classes.resetContainer}>
                        <Typography> {translations["steps completed please"] || 'All steps completed please click finish to save changes'} </Typography>
                        <Button onClick={cancelHandler} className={classes.button} variant="contained">
                            {translations["cancel"] || 'Cancel'}
                        </Button>
                        <Button onClick={() => setActiveSteps(1)} className={classes.button} variant="contained" >
                            {translations["back"] || 'BACK'}
                        </Button>
                        <Button color={'primary'} variant="contained" onClick={handleFinish}
                            style={{ width: '120px', margin: 10 }}
                        >
                            {activeStep === steps.length - 1 ? translations['save'] || 'SAVE' : translations['finish'] || 'FINISH'}
                        </Button>
                    </Paper>
                )}
            </div>
        </div>
    );
}
export default withStyles(styles, { withTheme: true })(RoleForCustomer);
